// doc: https://nhnent.github.io/tui.editor/api/latest/ToastUIEditor.html#ToastUIEditor
export default {
  minHeight: '200px',
  previewStyle: 'vertical',
  useCommandShortcut: true,
  useDefaultHTMLSanitizer: true,
  usageStatistics: false,
  hideModeSwitch: false,
  toolbarItems: [
    [
      'heading',
      'bold',
      'italic',
      'strike',
    ],
    [
      'hr',
      'quote',
    ],
    [
      'ul',
      'ol',
      'task',
      'indent',
      'outdent',
    ],
    [
      'table',
      'image',
      'link',
    ],
    [
      'code',
      'codeblock'
    ]
  ]
}
